import JraEncodeDecodeModule from './JraEncodeDecodeModule';

import {
  disableInputs,
} from '../helpers';

export default class JraPrimary extends JraEncodeDecodeModule {
  static PRIMARY_EMAIL_CHANGE_EVENT = 'primaryEmailChangeEvent';

  constructor(element, encodeDecodeKey, isJoinForm = true) {
    super(encodeDecodeKey);

    this.element = element;

    this.primaryMemberNameInputs = [...this.element.querySelectorAll('[data-jra-form-primary-name]')];
    this.primaryEmailInput = this.element.querySelector('[data-jra-form-primary-email]');

    if (!isJoinForm && this.primaryMemberNameInputs.length) {
      disableInputs(this.primaryMemberNameInputs);
    }


    // run secondary email validation if a user inputs primary email after secondary email.
    // this hasn't been added as a separate validator for primary email because
    // we are triggering other code and are not checking if primary email is valid.
    if (this.primaryEmailInput) {
      this.primaryEmailInput.addEventListener('change', () => {
        this.emit(JraPrimary.PRIMARY_EMAIL_CHANGE_EVENT);
      });
    }
  }
}
